import { Table } from "@components/modules/notifications/listing";
import { AppSubNav } from "@components/widgets/AppSubNav/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout
    title={t`Notifications`}
    navigation={<AppSubNav />}
    minH="auto"
    h="auto"
  >
    <Table />
  </MainLayout>
);

export const Route = createFileRoute("/notifications/")({
  component: Page,
});
